<div data-test-id="objective-selector-other-okrs-session">
  <single-goal-selector-session-row [session]="session.data" (sessionSelected)="selectSessionFromList($event)"></single-goal-selector-session-row>
  <div *ngIf="session.children">
    <div class="sp-pl-20" *ngFor="let childSession of session.children">
      <single-goal-selector-session-tree [session]="childSession" (sessionSelected)="selectSessionFromList($event)"> </single-goal-selector-session-tree>
    </div>
  </div>
</div>
